// extracted by mini-css-extract-plugin
module.exports = {"supportPage":"Support_supportPage__2fwo4","heading":"Support_heading__A-W8n"};